//Blender资源管理

import { InboxOutlined } from "@ant-design/icons";
import { Card, Input, Form, message, Button } from "antd";
import TextArea from "antd/es/input/TextArea";
import Dragger from "antd/es/upload/Dragger";
import { useState } from "react";

import { useTranslation } from 'react-i18next';

import { uploadBlenderResourceAPI } from "@/apis/blenderRes";

const layout = {
    labelCol: {
        span: 6,
        style: {
            whiteSpace: 'normal',
            lineHeight: '1.4',
            textAlign: 'right',
            fontWeight: '500',
            paddingRight: '12px',
        }
    },
    wrapperCol: {
        span: 18,
    },
};
const BlenderResourceManage = () => {
    useTranslation();
    const [fileList, setFileList] = useState([]);
    const [form] = Form.useForm();

    const onFinish = async (values) => {
        try {
            if (fileList.length === 0) {
                message.error('请选择要上传的文件');
                return;
            }

            const formData = new FormData();
            formData.append('resourceName', values.resourceName);
            formData.append('aircraftSortie', values.aircraftSortie);
            formData.append('description', values.description || '');
            formData.append('file', fileList[0].originFileObj);

            await uploadBlenderResourceAPI(formData);
            message.success('上传成功！');

            // 重置表单和文件列表
            form.resetFields();
            setFileList([]);
        } catch (error) {
            console.error('Upload failed:', error);
            message.error('上传失败，请重试');
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const uploadProps = {
        beforeUpload: (file) => {
            // 阻止自动上传
            return false;
        },
        onChange: (info) => {
            setFileList(info.fileList.slice(-1)); // 只保留最后一个文件
        },
        fileList: fileList,
        onRemove: () => {
            setFileList([]);
        },
    };

    return (
        <div>
            <Card
                style={{
                    width: '100%',
                    minHeight: '100%',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    overflow: 'hidden',
                }}
                title="blender资源上传"
                styles={{
                    body: {
                        padding: '0',
                        height: '100%',
                        overflow: 'auto',
                    }
                }}>
                <div style={{
                    width: '100%',
                    padding: '20px',
                    maxHeight: 'calc(100vh - 120px)',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}>
                    <Form
                        {...layout}
                        form={form}
                        name="basic"
                        style={{
                            width: '100%',
                            maxWidth: '800px',
                            margin: '0 auto',
                            minWidth: '0',
                            boxSizing: 'border-box',
                        }}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >

                        <Form.Item
                            label="资源名称"
                            name="resourceName"
                            required={true}
                        >
                            <Input placeholder="请输入资源名称" />
                        </Form.Item>

                        <Form.Item
                            label="飞机架次"
                            name="aircraftSortie"
                            required={true}
                        >
                            <Input placeholder="请输入飞机架次" />
                        </Form.Item>

                        <Form.Item
                            label="详细描述(非必须)"
                            name="description"
                        >
                            <TextArea placeholder="请输入详细描述" />
                        </Form.Item>

                        <Form.Item
                            label="上传文件"
                            name="file"
                            required={true}
                        >
                            <Dragger {...uploadProps}>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">点击或拖拽文件到此区域上传</p>
                                <p className="ant-upload-hint">
                                    支持单个或批量上传。严禁上传公司数据或其他禁止文件。
                                </p>
                            </Dragger>
                        </Form.Item>

                        <Form.Item label={null}>
                            <Button type="primary" htmlType="submit">
                                提交上传
                            </Button>
                            <Button
                                type="default"
                                style={{ marginLeft: '10px' }}
                                onClick={() => {
                                    form.resetFields();
                                    setFileList([]);
                                    message.info('表单已重置');
                                }}
                            >
                                重置
                            </Button>
                        </Form.Item>

                    </Form>
                </div>
            </Card>

        </div>
    );
};

export default BlenderResourceManage;